export const isStringBoolean = (value: string): boolean => {
  return value === 'true' || value === 'false';
};

export const parseStringBoolean = (value: string): boolean => {
  return value === 'true';
};
